const types = {
  SET_SEGMENT: "SET_SEGMENT",
  SET_EXTRACT: "SET_EXTRACT",
  SET_RESIDENCE_TYPE: "SET_RESIDENCE_TYPE",
  SET_POSICION_HOGAR: "SET_POSICION_HOGAR",
  SET_EDUCATIONAL_LEVEL: "SET_EDUCATIONAL_LEVEL",
  SET_SIMULATION: "SET_SIMULATION",
  SET_HOUSING_CLASS: "SET_HOUSING_CLASS",
  SET_FINANCIAL_COMMITMENTS: "SET_FINANCIAL_COMMITMENTS",
  SET_FINANCE_INFORMATION_ONE: "SET_FINANCE_INFORMATION_ONE",
  SET_FINANCE_INFORMATION_TWO: "SET_FINANCE_INFORMATION_TWO",
  SET_DOCUMENT_TYPE: "SET_DOCUMENT_TYPE",
  SET_ARCHIVE: "SET_ARCHIVE",
  REMOVE_ARCHIVE: "REMOVE_ARCHIVE",
  SET_DOCUMENT_TYPE_INCOME: "SET_DOCUMENT_TYPE_INCOME",
  REMOVE_ARCHIVE_INCOME: "REMOVE_ARCHIVE_INCOME",
  SET_ARCHIVE_INCOME: "SET_ARCHIVE_INCOME",
  SET_MORTGAGE_PAYMENT: "SET_MORTGAGE_PAYMENT",
  SET_OTHER_CERTIFIED: "SET_OTHER_CERTIFIED",
  SET_MORTGAGE_CREDIT: "SET_MORTGAGE_CREDIT",
  SET_CREDIT: "SET_CREDIT",
  SET_LAST_CREDIT: "SET_LAST_CREDIT",
  SET_SOLICITATION: "SET_SOLICITATION",
  SET_GLOBAL_DEBIT_CALCULATION: "SET_GLOBAL_DEBIT_CALCULATION",
  SET_BASIC_REQUEST_INFORMATION: "SET_BASIC_REQUEST_INFORMATION"
}

export default types
